import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GgwProfilesComponent } from './components/ggw-profiles/ggw-profiles.component';
import {ButtonModule, DataTableModule} from "primeng/primeng";
import {UIBaseModule} from "@catui/ui-base.module";
import { ModifyGgwProfileComponent } from './components/modify-ggw-profile/modify-ggw-profile.component';
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {UIFormModule} from "@catuiform/ui-form.module";
import {ParametersModule} from "@catmodels/parameters/parameters.module";
import {GgwProfilePolicyService} from "@catmodels/ggw-profiles/services/ggw-profile-policy.service";
import {GgwProfileService} from "@catmodels/ggw-profiles/services/ggw-profile.service";
import { GgwDeviceAccessComponent } from './components/ggw-device-access/ggw-device-access.component';

@NgModule({
  entryComponents: [
    ModifyGgwProfileComponent
  ],
  imports: [
    CommonModule,
    DataTableModule,
    UIBaseModule,
    ButtonModule,
    FormsModule,
    UIFormModule,
    ReactiveFormsModule,
  ],
  declarations: [
    GgwProfilesComponent,
    ModifyGgwProfileComponent,
    GgwDeviceAccessComponent,
  ],
  providers: [
    GgwProfilePolicyService,
    GgwProfileService,
  ]
})
export class GgwProfilesModule { }



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_develop@2/app/Resources/Public/src/app/modules/models/ggw-profiles/ggw-profiles.module.ts